import React from 'react';
import { View, Text } from 'react-native';
import Terms from '../../components/Terms'
import { styles } from './styles';
import HeaderDefault from '../../components/HeaderDefault'
const TermsService = () => (
  <View style={{ flex: 1 }}>
    <HeaderDefault title={'Termos de uso'} />
    <Terms />
  </View>
)
export default TermsService